module.exports = __webpack_public_path__ + "static/media/Test42.f8a7b377.bmp";